export default __webpack_public_path__ + "static/media/structure_yellow.b3769733.svg";